// Converts any API error into learner-safe text — never an object, never internal metadata.
export function errorText(e, t, fallbackKey = "friend.live.genericError") {
  const status = e?.response?.status;
  if (status === 402) return t("friend.live.premium");
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim() && status < 500) return detail;
  return t(fallbackKey);
}
